import "./Values.scss";

import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import Card from "../../../components/Card/Card";
import useAnimation from "../../../hooks/useAnimation";
import getImageUrl from "../../../Utils/Services/img/imgFetch";

const Values: React.FC = () => {
  const { t } = useTranslation();
  const { animateFadeInWithMove } = useAnimation();

  const initAnimation = () => {
    const section = document.querySelectorAll(".valuesSection");
    animateFadeInWithMove(section, 0.6, section);
  };

  useEffect(() => {
    const timeoutId = setTimeout(initAnimation, 1000);
    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <div className="valuesSectionDiv" id="values">
      <section className="valuesSection" id="valuesSection">
        <h2>{t("home.values.title")}</h2>
        <div className="valuesGrid">
          <Card type="primary">
            <img
              src={getImageUrl("values/accessibilite.png")}
              alt={t("home.values.accessibilityTitle")}
            />
            <h3>{t("home.values.accessibilityTitle")}</h3>
            <p>{t("home.values.accessibilityText")}</p>
          </Card>
          <Card type="primary">
            <img
              src={getImageUrl("values/respect-environnement.jpg")}
              alt={t("home.values.environmentTitle")}
            />
            <h3>{t("home.values.environmentTitle")}</h3>
            <p>{t("home.values.environmentText")}</p>
          </Card>
          <Card type="primary">
            <img
              src={getImageUrl("values/innovations.JPG")}
              alt={t("home.values.innovationTitle")}
            />
            <h3>{t("home.values.innovationTitle")}</h3>
            <p>{t("home.values.innovationText")}</p>
          </Card>
          <Card type="primary">
            <img
              src={getImageUrl("values/bienveillance.JPG")}
              alt={t("home.values.bienveillanceTitle")}
            />
            <h3>{t("home.values.bienveillanceTitle")}</h3>
            <p>{t("home.values.bienveillanceText")}</p>
          </Card>
        </div>
      </section>
    </div>
  );
};

export default Values;
